export async function updateApplicationTable(template, applicationTable, layer, layerItem) {
  if (!applicationTable || applicationTable.sourceLayer !== layer) {
    return;
  }

  const target = document.querySelector(`div.template svg #${applicationTable.elementId}`);

  if (!target) {
    return;
  }

  try {
    const layerUrl = new URL(
      route('social-graphics.layers.index', {
        template,
        layer: applicationTable.sourceLayer,
      }),
      window.location.origin,
    );

    layerUrl.pathname = layerUrl.pathname.replace(
      /\/layers\/[^/]+$/,
      `/application-tables/${encodeURIComponent(layerItem)}`,
    );

    const response = await window.axios.get(
      layerUrl.toString(),
      { responseType: 'text' },
    );
    const applicationTableDocument = new DOMParser().parseFromString(response.data, 'image/svg+xml');
    const replacement = applicationTableDocument.getElementById(applicationTable.elementId);

    if (!replacement) {
      throw new Error(`Application table is missing #${applicationTable.elementId}.`);
    }

    target.replaceWith(document.importNode(replacement, true));
  } catch (error) {
    target.setAttribute('visibility', 'hidden');
    console.error('Unable to load the application table.', error);
  }
}

export function applyApplicationTableSettings(applicationTable, settings = {}) {
  if (!applicationTable?.elementId) {
    return;
  }

  const target = document.querySelector(`div.template svg #${applicationTable.elementId}`);

  if (!target) {
    return;
  }

  const color = settings.color ?? applicationTable.defaultColor;
  const enabled = settings.status ?? Boolean(applicationTable.enabled);

  if (color) {
    target.setAttribute('fill', `rgba(${color},1)`);
  }

  target.setAttribute('visibility', enabled ? 'visible' : 'hidden');
}
